<template>
  <div class="openOrder">
    <div class="orderLeft">
      <!-- <div class="orderTit">
        <span>体验券订单</span>
        <span class="tag">
          <el-tag class="greenT">促单跟进</el-tag>
        </span>
      </div>
      <el-table
        :data="tableData"
        border
        class="orderTable"
        style="width: 100%"
        @cell-dblclick="confirmTel"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" prop="memberName" label="会员">
          <template slot-scope="scope">{{scope.row.memberName | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="memberPhone" label="手机号码" width='120'></el-table-column>
        <el-table-column align="center" prop="serviceName" label="商品标题">
          <template slot-scope="scope">
            <el-row class="tableGoods">
              <el-popover trigger="hover" placement="top">
                {{scope.row.serviceName}}
                <el-col slot="reference" class="myTitle">
                  <span>{{scope.row.serviceName | filterRow}}</span>
                </el-col>
              </el-popover>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="num" label="体验券数量"></el-table-column>
        <el-table-column align="center" prop="createTime" label="预约人数">
          <template slot-scope="scope">{{scope.row.createTime | formatDateLiness | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="creatTime" label="创建时间">
          <template slot-scope="scope">
            <span>2018-11-14</span>
            <p>10:44:45</p>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="flag" label="是否确认">
          <template slot-scope="scope">
            <span class="red">未确认</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="flag" label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" class="greenbtn" @click="confirmTel(scope.row)">电话确认</el-button>
          </template>
        </el-table-column>
      </el-table> -->
      <!-- <div class="orderTit">
        <span>今日预约单监控</span>
        <span class="tag">
          <el-tag class="redT">超时未接单</el-tag>
        </span>
      </div> -->
      <!-- <el-table
        :data="tableData1"
        border
        class="orderTable"
        style="width: 100%"
        @cell-dblclick="dispatch"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" prop="memberName" label="会员">
          <template slot-scope="scope">{{scope.row.memberName | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="memberPhone" label="手机号码" width='120'></el-table-column>
        <el-table-column align="center" prop="serviceList" label="项目">
          <template slot-scope="scope">
            <el-row class="tableGoods">
              <el-popover trigger="hover" placement="top">
                <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                <el-col slot="reference" class="myTitle">
                    <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                </el-col>
              </el-popover>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="technicianName" label="调理师"></el-table-column>
        <el-table-column align="center" prop="scheduleStartTime" label="预约时间">
          <template slot-scope="scope">
            {{scope.row.scheduleStartTime | filterTime | filterRow}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createTime | filterTime | filterRow}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <span class="red">{{scope.row.status | filterAtatus}}</span>
            <p>{{scope.row.notTakingOverTimeMins>0?'超时'+scope.row.notTakingOverTimeMins+'min':''}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="flag" label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" class="redbtn" @click="dispatch(scope.row)">人工派单</el-button>
          </template>
        </el-table-column>
      </el-table> -->
      <div class="orderTit">
        <span>今日服务单监控</span>
        <span class="tag">
          <el-tag class="yellowT">待服务</el-tag>
        </span>
      </div>
      <el-table
        :data="tableData2"
        border
        class="orderTable"
        style="width: 100%"
        @cell-dblclick="onOrder"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" prop="memberName" label="会员">
          <template slot-scope="scope">{{scope.row.memberName | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="memberPhone" label="手机号码" width='120'></el-table-column>
        <el-table-column align="center" prop="serviceList" label="项目">
          <template slot-scope="scope">
            <el-row class="tableGoods">
              <el-popover trigger="hover" placement="top">
                <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                <el-col slot="reference" class="myTitle">
                    <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                </el-col>
              </el-popover>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="technicianName" label="调理师"></el-table-column>
        <el-table-column align="center" prop="scheduleStartTime" label="预约时间">
          <template slot-scope="scope">{{scope.row.scheduleStartTime | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <span class="red">{{scope.row.status | filterAtatus}}</span>
            <p>{{scope.row.unstartOverTimeMins>0?'超时'+scope.row.unstartOverTimeMins+'min':''}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="flag" label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" class="yellowbtn" @click="onOrder(scope.row)">开始服务</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="orderTit">
        <span>服务单监控</span>
        <span class="tag">
          <el-tag class="blueT">服务中</el-tag>
        </span>
      </div>
      <el-table
        :data="tableData3"
        border
        class="orderTable"
        style="width: 100%"
        @cell-dblclick="overOrder"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" prop="memberName" label="会员">
          <template slot-scope="scope">{{scope.row.memberName | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="memberPhone" label="手机号码" width='120'></el-table-column>
        <el-table-column align="center" prop="serviceList" label="项目">
          <template slot-scope="scope">
            <el-row class="tableGoods">
              <el-popover trigger="hover" placement="top">
                <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                <el-col slot="reference" class="myTitle">
                    <span v-for="(i,index) in scope.row.serviceList" :key="index">{{i.serviceName}}{{scope.row.serviceList.length-1 == index ? '' : '，'}}</span>
                </el-col>
              </el-popover>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="technicianName" label="调理师"></el-table-column>
        <el-table-column align="center" prop="startTime" label="开始时间">
          <template slot-scope="scope">{{scope.row.startTime | filterTime | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <span class="red">{{scope.row.status | filterAtatus}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="flag" label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" class="bluebtn" @click="overOrder(scope.row)">结束服务</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="orderRight">
      <div class="resourceMonitor">
        <h2>门店资源情况</h2>
        <div class="orderContent">
          <el-row class="list" v-for='(i,index) in staffList' :key="index">
            <el-col :span="10">
              {{i.name.length > 5 ? i.name.substr(0,5)+'···':i.name}}
              <span class="tag" :class="{'full':i.jobCategory == 1,'part':i.jobCategory == 2}">{{i.jobCategory == 1?'全':(i.jobCategory == 2?'兼':'')}}</span>
            </el-col>
            <el-col :span="10">{{i.postId | filterPostId(infolist.postIdData) | filterRow}}</el-col>
            <el-col :span="4">
              <span :class="{'free':i.status == 0}">{{i.status == 0 ? '空闲':'服务中'}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="dialogType === 1 ? '电话确认':(dialogType === 2 ? '人工派单':(dialogType === 3 ? '确认开始服务':(dialogType === 4 ? (nextPart?'确认结束服务':'预约下次服务'):'')))" class="dialogVisible" :visible.sync="dialogTableVisible" :center="true" width="580px">
        <confirmTel :dialogTableVisible="dialogTableVisible" :dialogType="dialogType" :nextPart="nextPart" @closeDialog="closeDialog" @cancelDialog="cancelDialog" @refresh="refresh" :curRowchoose="curRowchoose" />
    </el-dialog>
    <el-dialog class="dialogVisible" :visible.sync="dialogSetpwd" :center="true" width="800px">
        <setPwd :setpayPwd="setpayPwd" :dialogSetpwd="dialogSetpwd" @closeset="closeset"/>
    </el-dialog>
  </div>
</template>
<script>
import infolist from '@/assets/js/info'
import {queryMemberBirthInfo, technicianList, serviceOrderList} from '@/api';     
import {formatDate} from '@/components/common/js/date.js';                    
import confirmTel from './confirmTel';
import setPwd from '@/components/basicDataCenter/setPsd'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}
let Notification;

export default {
    props: ['refreshFlag'],
    components: {
        confirmTel,setPwd
    },
  data() {
    return {
      infolist:infolist,
      tableData1:[],
      tableData2:[],
      tableData3:[],
      staffList:'',
      dialogTableVisible: false,
      dialogSetpwd:false,//设置消费密码弹框
      dialogType:'',// 几个弹窗的识别
      curRowchoose:'',//选中的数据
      nextPart:true,//结束服务单默认有下一步选择下次预约时间
      setpayPwd:'',//设置密码标识，是否加入会员
      birthdayMem:0,
    };
  },
  mounted() {
    this.search();
    // this.tableData(1,1);
    this.tableData(2,0);
    this.tableData(3,0);
  },
  watch: {
    $route(to){
      if(to.redirectedFrom === '/operatingFloor'){
        this.search();
        // this.tableData(1,1);
        this.tableData(2,0);
        this.tableData(3,0);
      }
    },
    refreshFlag(){
      this.search();
      // this.tableData(1,1);
      this.tableData(2,0);
      this.tableData(3,0);
    }
  },
  methods: {
    tableData(type,overTimeFlag){
        serviceOrderList({
          pageSize: 10,
          currentPage: 1,
          todayFlag:type == 3 ? '0':'1',
          overTimeFlag:overTimeFlag,
          status:type,
        }).then(res=>{
          if(type == 1){
            this.tableData1 = res.data.items;
          }else if (type == 2){
            this.tableData2 = res.data.items;
            if(this.tableData2.length > 0){
              for(let list of this.tableData2){
                if(list.scheduleStartTime){
                  list.scheduleStartTime = formatDate(list.scheduleStartTime,'MM-dd ')+formatDate(list.scheduleStartTime,'HH:mm')+'-'+formatDate(list.scheduleEndTime,'HH:mm')
                }
              }
            }
          }else{
            this.tableData3 = res.data.items;
          }
        })
    },
    search(){
      technicianList({
        // status:'1',
        // deleteFlag:'0',
        // postId:'0'
      }).then(res => {
        this.staffList = res.data;
      })

      queryMemberBirthInfo({
        startDate: formatDate(new Date() , 'yyyy-MM-dd'),
        endDate: formatDate(new Date(new Date().getTime() + 3600 * 1000 * 24 * 30) ,'yyyy-MM-dd')
      }).then(resData=>{
        this.birthdayMem = resData.data.count;
        if(this.birthdayMem > 0){
          if(Notification){
            Notification.close();
            Notification = '';
          }
          Notification = this.$notify({
            dangerouslyUseHTMLString:true,
            message: '<span class="redBirthday"><i class="cake"></i>&nbsp;&nbsp;三十天内有'+ this.birthdayMem +'位会员过生日，<u>点击查看</u>详情！</span>',
            position: 'top-left',
            showClose: false,
            duration:7000,
            offset:55,
            onClick:()=>{
              this.toMemBirthday(this.birthdayMem,resData.data.list[0].memberId)
            }
          });
        }
        
      })
      
    },
    toMemBirthday(number,memberId){
      if(number > 1){
        this.$store.commit("setAliveStatus", true);//保留列表页状态
        this.$router.push({name:"查询会员",params:{type:'birthday'}});
        // Notification.close();
      }else{
        // 只有一位跳转详情
        this.$router.push("/basicDataCenter/id=" + memberId);
        this.$store.commit('setAlivePage',1)
      }
    },
    confirmTel(row) {
      //   电话确认
      this.dialogTableVisible = true;
      this.dialogType = 1;
      this.curRowchoose = row;
    },
    dispatch(row){
      // 人工派单
      this.dialogTableVisible = true;
      this.dialogType = 2;
      this.curRowchoose = row;
    },
    onOrder(row){
      // 确认开单
      this.dialogTableVisible = true;
      this.dialogType = 3;
      this.curRowchoose = row;
    },
    overOrder(row){
      // 结束服务
      this.dialogTableVisible = true;
      this.dialogType = 4;
      this.curRowchoose = row;
      this.nextPart = true;
    },
    closeDialog(val){
      this.dialogTableVisible = val;
      this.search();
      this.tableData(1,0);
      this.tableData(2,0);
      this.tableData(3,0);
      if(val === 'nextPart'){
        this.nextPart = true;
        this.dialogTableVisible = false;
      }
    },
    cancelDialog(val){
      this.dialogTableVisible = false;
      this.dialogSetpwd = true;
      this.setpayPwd = val;
    },
    closeset(val){
      this.dialogSetpwd = val;
      this.dialogTableVisible = true;
      this.dialogType = 3;
    },
    refresh(val){
      this.search();
      this.tableData(1,0);
      this.tableData(2,0);
      this.tableData(3,0);
      if(val.isAppointStatus == 1){
        this.nextPart = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.openOrder {
  width: 1150px;
  margin: 0 auto 30px;
  overflow: hidden;
  .orderLeft {
    width: 65%;
    display: inline-block;
    .orderTit {
      font-size: 18px;
      color: #222;
      font-weight: bold;
      margin: 20px 0 15px;
      .tag {
        margin-left: 10px;
        .el-tag {
          padding: 0 10px;
          height: 24px;
          line-height: 22px;
          color: #fff;
          font-size: 13px;
          font-weight: normal;
          border-radius: 0px 18px 18px 18px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          white-space: nowrap;
          &.greenT {
            background-color: #2ecfa7;
            border: 1px solid #2ecfa7;
          }
          &.redT {
            background-color: #f96479;
            border: 1px solid #f96479;
          }
          &.yellowT {
            background-color: #ffb932;
            border: 1px solid #ffb932;
          }
          &.blueT {
            background-color: #42acef;
            border: 1px solid #42acef;
          }
        }
      }
    }
    .orderTable {
      .el-button--mini {
        padding: 7px 0;
        width: 68px;
        border: none;
      }
      .greenbtn {
        background: #2ecfa7;
        color: #fff;
      }
      .redbtn {
        background: #f96479;
        color: #fff;
      }
      .yellowbtn {
        background: #ffb932;
        color: #fff;
      }
      .bluebtn {
        background: #42acef;
        color: #fff;
      }
      .tableGoods {
        .myTitle {
          width: 100%;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .orderRight {
    display: inline-block;
    vertical-align: top;
    margin: 30px 0 0 45px;
    width: 30%;
    max-width: 370px;
    background: #fff;
    box-shadow: 0px 0px 19px 0px rgba(65, 67, 85, 0.1);
    border-radius: 28px;
    h2 {
      width: 100%;
      height: 65px;
      line-height: 65px;
      font-size: 20px;
      text-align: center;
      background: #2ecfa7;
      border-radius: 28px 28px 0 0;
      color: #fff;
      font-weight: bold;
    }
    .orderContent {
      padding: 0 28px 35px;
      .list {
        height: 42px;
        line-height: 42px;
        border-bottom: 1px dashed #97e3d0;
        .tag {
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          border-radius: 10px;
          color: #fff;
          &.full {
            background: #2ecfa7;
          }
          &.part {
            background: #ffb932;
          }
        }
        .free {
          color: #2ecfa7;
          font-weight: bold;
        }
        .el-col-4 {
          text-align: center;
        }
      }
    }
  }
}
</style>
<style lang="less">
.redBirthday{
  color: #ff0000;
  cursor: pointer;
  .cake{
    width: 20px;
    height: 20px;
    background: url(../../assets/images/store/birthday.png) no-repeat;
    background-size:100%;
    display: inline-block;
    vertical-align: top;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/operatingFloor/openOrder.vue